export default __webpack_public_path__ + "static/media/Refined Elixir of Invigorative Rejuvenation.8a67a8e7.jpg";